import React, { useContext } from 'react'
import { homeLinkCardObj } from '../../Utils/variables/homeLinkCards'
import { Link } from 'react-router-dom'
import { LazyLoadImage } from 'react-lazy-load-image-component'
import { LinkCard } from './LinkCard'
import AuthProvider from '../../context/AuthContext';
import { isEmpty } from "lodash";
import { useNavigate } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query'
import apiPath from "../../Utils/apiPath";
import { apiGet } from "../../Utils/apiFetch";

const HomeList = () => {
    const navigate = useNavigate();
    let { launchCasino, user } = useContext(AuthProvider);

    const { data: inplayCountData = {} } = useQuery({
        queryKey: ["inPlayCount"],
        queryFn: async () => {
        const { status, data: res } = await apiGet(apiPath.inPlayCount);
        if (status === 200 && res?.status && res?.data) return res.data;
        return {};
        },    
    });
  return (
    <>
     <a href="#" neua="InPlay Banner">
        <dl className="entrance-title">
        <dt>Sports</dt>
        <dd>
            <span>Play Now</span>
        </dd>
        </dl>
        <dl
        id="onLiveBoard"
        onClick={() => navigate("/inplay")}
        className="on_live"
        >
        <dt>
            <p className="live_icon">
            <span></span> LIVE
            </p>
        </dt>

        <dd id="onLiveCount_CRICKET">
            <p>Cricket</p>
            <span id="count">
            {inplayCountData?.cricketInplayCount || 0}
            </span>
        </dd>

        <dd id="onLiveCount_SOCCER">
            <p>Soccer</p>
            <span id="count">
            {inplayCountData?.soccerInplayCount || 0}
            </span>
        </dd>

        {/* <dd id="onLiveCount_E_SOCCER">
            <p>E-Soccer</p>
            <span id="count">
            {inplayCountData?.soccerInplayCount || 0}
            </span>
        </dd> */}

        <dd id="onLiveCount_TENNIS">
            <p>Tennis</p>
            <span id="count">
            {inplayCountData?.tennisInplayCount || 0}
            </span>
        </dd>
        </dl>
        <Link to="/inplay">

        <LazyLoadImage
            effect="blur"
            src="/assets/images/15--Sports.png"
            alt=""
            style={{ height: `auto` }}
        />
        </Link>
    </a>
     {/* <a
        className="entrance"
        
        href="javascript:void(0)"
        onClick={() => {
        if (!isEmpty(user)) {
            window.open(process.env.REACT_APP_VELKIE_URL+"bkash/"+localStorage.getItem("token"), "_self");
        } else {
            navigate("/login");
        }
        }}
        >
        <dl className="entrance-title">
        <dt>Velki </dt>
        <dd>Play Now</dd>
        </dl>
        <LazyLoadImage 
        src={
            // process.env.REACT_APP_MOBILE_URL +
            "/assets/images/15--Sports.png"
        }
        alt=""
        />
    </a> */}
    {/* <a
        className="entrance"
        href="javascript:void(0)"
        onClick={() => {
        if (!isEmpty(user)) {
            launchCasino({
                platForm: "SABA",
                gameType: "VIRTUAL",
                casinoType: "SABA-VIRTUAL-001",
            });
        } else {
            navigate("/login");
        }
        }}
    >
        <dl className="entrance-title">
        <dt>Saba Sports</dt>
        <dd>Play Now</dd>
        </dl>
        <LazyLoadImage 
        src={
            // process.env.REACT_APP_MOBILE_URL +
            "/assets/images/spotsaba.webp"
        }
        alt=""
        />
    </a>
     <a
        className="entrance"
        href="javascript:void(0)"
        onClick={() => {
        if (!isEmpty(user)) {
            launchCasino({
            platForm: "SPRIBE",
            gameType: "EGAME",
            casinoType: "SPRIBE-EGAME-001",
            });
        } else {
            navigate("/login");
        }
        }}
    >
        <dl className="entrance-title">
        <dt>Aviator</dt>
        <dd>Play Now</dd>
        </dl>
        <LazyLoadImage 
        src={
            // process.env.REACT_APP_MOBILE_URL +
            "/assets/images/aviator11.webp"
        }
        alt=""
        />
    </a>
    <a
        className="entrance"
        
        href="javascript:void(0)"
        onClick={() => {
        if (!isEmpty(user)) {
            window.open(process.env.REACT_APP_VELKIE_URL+"bkash/"+localStorage.getItem("token"), "_self");
        } else {
            navigate("/login");
        }
        }}
        >
        <dl className="entrance-title">
        <dt>Velki </dt>
        <dd>Play Now</dd>
        </dl>
        <LazyLoadImage 
        src={
            // process.env.REACT_APP_MOBILE_URL +
            "/assets/images/velki.png"
        }
        alt=""
        />
    </a> */}
    
   

    {homeLinkCardObj.map((obj, index) => (
        <>
        <LinkCard data={obj} key={index}/>
        </>
    ))}
    </>
  )
}

export default HomeList